<template>
  <div>
    <slot name="title"/>
    <sFormItem
      ref="contactPerson"
      prop="contactPersonId">
      <TenderContactPersonItem
        :loading="loading"
        :peoples="spr.people"
        :value.sync="contactPerson"/>
    </sFormItem>
    <template
      v-if="additionalContactPerson || loading">
      <div class="h4-headline pb-3 px-0">
        {{ $t('Tenders.AdditionalContactPerson') }}
        <sButton
          icon="delete"
          small
          type="text"
          @click="additionalContactPerson = null"/>
      </div>
      <sFormItem
        v-if="additionalContactPerson"
        ref="additionalContactPersons"
        prop="additionalContactPersons">
        <TenderContactPersonItem
          :editable="isEditable(additionalContactPerson)"
          :loading="loading"
          :peoples.sync="spr.additionalPeople"
          prop-name="additionalContactPersons[0]."
          type="additional"
          :value="additionalContactPerson"
          @update:value="changeAdditionalContactPerson"/>
      </sFormItem>
    </template>
    <sButton
      v-else
      class="add-additional-person"
      data-qa="add-additional-person"
      icon="plus"
      small
      type="text"
      @click="addAdditional">
      {{ $t('Tenders.AddAnotherContactPerson') }}
    </sButton>
  </div>
</template>
<script>
import TenderContactPersonItem from 'components/tenderCreation/block/TenderContactPersonItem.vue'
import editTenderMixin from 'mixins/editTenderMixin'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

const defaultPerson = {
  contactId: '',
  email: '',
  name: '',
  phone: ''
}
/**
 * Создание тендера. Блок с контактным лицом
 */
export default {
  name: 'TenderContactPerson',
  mixins: [ editTenderMixin ],
  data() {
    return {
      loading: true,
      spr: {
        people: [],
        additionalPeople: [],
      },
      errors: {
        contactPerson: {
          name: false,
          phone: false,
          email: false,
        },
        additionalContactPerson: false,
      },
    }
  },
  methods: {
    isEditable(persona) {
      if (this.loading) {
        return false
      }
      return !this.spr.people?.some(item =>  item?.contactId == persona?.contactId)
        && !this.spr.additionalPeople?.some(item =>  item?.contactId == persona?.contactId)
    },
    async fetchContacts(start) {
      this.loading = start

      let mapFunc = item => ({...item, phone: item.phone || '', name: item.name || item.email || '', hidden: item.hidden})
      let sortFunc = (a, b) => a?.name?.localeCompare(b?.name)

      let promices = []
      if (!this.spr.people?.length) {
        promices.push(
          api.tenderContactPersons()
            .then(res => {
              this.spr.people = res?.map(mapFunc)?.sort(sortFunc) || []
            }))
      }

      if (start || !this.spr.additionalPeople?.length) {
        promices.push(
          api.getAdditionalContactPeople()
            .then(res => {
              this.spr.additionalPeople = res?.map(mapFunc)?.sort(sortFunc) || []
            }))
      }
      await Promise.all(promices)
      this.loading = false
    },
    addAdditional() {
      this.fetchContacts()
      this.additionalContactPerson = this.$_.cloneDeep(defaultPerson)
      this.$nextTick(() => {
        this.$emit('clearValidate')
      })
      //this.chosed.push({contactId: 0, email: '', name: '', phone: '', search: ''})
    },
    changeAdditionalContactPerson(value) {
      this.additionalContactPerson = value
    }
  },
  computed: {
    title() {
      const label = this.$t('Tenders.ContactPerson')
      return label.charAt(0).toUpperCase() + label.slice(1)
    },
    contactPerson: {
      get() {
        if (!this.value?.contactPersonId) {
          return {}
        }
        let ret = this.$_.cloneDeep(this.spr.people).find(el => el.contactId == this.value.contactPersonId)
        return ret ? ret : this.$_.cloneDeep(defaultPerson)
      },
      set(person) {
        const result = this.$_.cloneDeep(this.value)
        result.contactPersonId = person?.contactId
        this.$emit('update:value', result)
        this.mixin_sendChangeFormItem('contactPerson', result.contactPersonId)
      }
    },
    additionalContactPerson: {
      get() {
        return this.value.additionalContactPersons?.[0] || null
      },
      set(person) {
        const result = this.$_.cloneDeep(this.value)

        delete person?.__typename
        result.additionalContactPersons = person ? [person] : []
        const needValidate = !!this.value?.additionalContactPersons?.length

        this.$emit('update:value', result)

        if (this.$refs.additionalContactPersons && needValidate) {
          this.mixin_sendChangeFormItem('additionalContactPersons', result.additionalContactPersons)
        }
      }
    },
    /**
    next_disable() {
      return !this.contactPerson?.contactId || this.chosed.some((el, n) => {
        if (!el) { return }
        let has_values = el && Object.values(el).some(el => el && el != this.phone_mask),
          non_info = () => (!el.phone || el.phone == this.phone_mask) && !el.email  ,
          not_valid = () => (el.phone != this.phone_mask && el.phone?.includes('–')) || typeof this.mailRules(el.email) == 'string'
        return has_values && !el.contactId && ((!el.name && !this.editing[n]) || (non_info() || not_valid()))
      })
    },
    */
  },
  components: {
    TenderContactPersonItem
  },
  async mounted() {
    await this.fetchContacts(true)
  },
  props: {
    value: {
      type: Object
    }
  },
}
</script>
